// extracted by mini-css-extract-plugin
export default {"wrapper":"App-module__wrapper--def86"};